import * as Yup from 'yup';

import { COUNT_LIMIT } from './countLimit';

export const YUP_SCHEMA = {
  REQUIRED: Yup.string().required(),
  NOT_REQUIRED: Yup.string().notRequired(),
  USER_NAME: Yup.string()
    .matches(/^[A-Za-z0-9]*$/, { message: 'profile.username_format_validation_message' })
    .min(6, 'register.userinfo_username_format_validation_message')
    .max(25, 'register.userinfo_username_format_validation_message')
    .required('register.userinfo_username_format_validation_message'),
  WRITER_NAME: Yup.string()
    // .matches(/^[a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣぁ-んァ-ン~!@#$%^&*()_\-+\[\]{}":<>?ー。]*$/, {
    .matches(/^[a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ~!@#$%^&*()_\-+\\[\]{}":<>?]*$/, {
      message: 'register.userinfo_writername_format_validation_message',
    })
    .min(2, 'register.userinfo_writername_format_validation_message')
    .max(25, 'register.userinfo_writername_format_validation_message')
    .required('register.userinfo_writername_format_validation_message'),
  PASSWORD: Yup.string()
    .matches(/^([a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]+)$/, {
      message: 'setting.edit_password_change_your_password_validation_text',
    })
    .min(8, 'setting.edit_password_change_your_password_validation_text')
    .max(25, 'setting.edit_password_change_your_password_validation_text')
    .required('setting.edit_password_change_your_password_validation_text'),
  TAG_LENGTH_LIMIT: Yup.array().min(1).max(COUNT_LIMIT.TAG),
  CHARACTER_NAME_LENGTH_LIMIT: Yup.string().min(1).max(COUNT_LIMIT.CHARACTER_NAME).required(),
  CHARACTER_STATUS_LENGTH_LIMIT: Yup.string().min(1).max(COUNT_LIMIT.CHARACTER_STATUS).required(),
  EMAIL: Yup.string()
    .matches(/^[a-zA-Z0-9+-\_.]{1,64}@[a-zA-Z-]+\.[a-zA-Z]+$/, {
      message: 'setting.edit_email_verify_validation_text',
    })
    .max(320, 'setting.edit_email_verify_validation_text')
    .required(''),
};

export default YUP_SCHEMA;
